/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthImport } from './routes/_auth'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as StoriesStoryIdImport } from './routes/stories_/$storyId'
import { Route as AuthAiImport } from './routes/_auth/ai'

// Create/Update Routes

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const StoriesStoryIdRoute = StoriesStoryIdImport.update({
  id: '/stories_/$storyId',
  path: '/stories/$storyId',
  getParentRoute: () => rootRoute,
} as any)

const AuthAiRoute = AuthAiImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_auth/ai': {
      id: '/_auth/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AuthAiImport
      parentRoute: typeof AuthImport
    }
    '/stories_/$storyId': {
      id: '/stories_/$storyId'
      path: '/stories/$storyId'
      fullPath: '/stories/$storyId'
      preLoaderRoute: typeof StoriesStoryIdImport
      parentRoute: typeof rootRoute
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthAiRoute: typeof AuthAiRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAiRoute: AuthAiRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthRouteWithChildren
  '/ai': typeof AuthAiRoute
  '/stories/$storyId': typeof StoriesStoryIdRoute
  '/': typeof AuthIndexRoute
}

export interface FileRoutesByTo {
  '/ai': typeof AuthAiRoute
  '/stories/$storyId': typeof StoriesStoryIdRoute
  '/': typeof AuthIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/ai': typeof AuthAiRoute
  '/stories_/$storyId': typeof StoriesStoryIdRoute
  '/_auth/': typeof AuthIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '' | '/ai' | '/stories/$storyId' | '/'
  fileRoutesByTo: FileRoutesByTo
  to: '/ai' | '/stories/$storyId' | '/'
  id: '__root__' | '/_auth' | '/_auth/ai' | '/stories_/$storyId' | '/_auth/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  StoriesStoryIdRoute: typeof StoriesStoryIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  StoriesStoryIdRoute: StoriesStoryIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/stories_/$storyId"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/ai",
        "/_auth/"
      ]
    },
    "/_auth/ai": {
      "filePath": "_auth/ai.tsx",
      "parent": "/_auth"
    },
    "/stories_/$storyId": {
      "filePath": "stories_/$storyId.tsx"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
